import { webviewInfo, os } from '@ali/amap-lib';

const userAgent = window.navigator.userAgent;

/**
 * 判断是否在微博中.
 * @return {Boolean} 在微博客户端中返回true
 */
webviewInfo.isInWeibo = () => {
  return / Weibo /i.test(userAgent);
};

/**
 * 判断是否在微信中.
 * @return {Boolean} 在微信中返回true
 */
webviewInfo.isInWeixin = () => {
  if (os.android) {
    return / MicroMessenger\//i.test(userAgent);
  }
  return / MicroMessenger\//i.test(userAgent);
};

/**
 * 判断是否在 QQ 中
 * @return {boolean} 在 QQ 客户端中返回 true
 */
webviewInfo.isInQQ = () => {
  return / QQ\//i.test(userAgent);
};

/**
 * 判断是否在钉钉中
 * @return {boolean} 在钉钉客户端中返回 true
 */
webviewInfo.isInDingTalk = () => {
  return / AliApp\(DingTalk\//i.test(userAgent);
};

/**
 * 判断是否在支付宝中
 * @return {boolean} 在支付宝客户端中返回 true
 */
webviewInfo.isInAlipay = () => {
  return / AliApp\(AP\//i.test(userAgent);
};

/**
 * 判断是否在 阿里系 App 中
 * @return {Boolean} 在阿里系 App 中返回 true
 */
webviewInfo.isInAliApp = () => {
  return / AliApp\(*\//i.test(userAgent);
};

/**
 * 判断是否在 UC 浏览器中
 * @return {Boolean} 在 UC 浏览器中返回 true
 */
webviewInfo.isInUC = () => {
  return / UCBrowser/i.test(userAgent);
};

/**
 * QQ 浏览器
 * @return {Boolean}
 */
webviewInfo.isInQQBrowser = () => {
  return / MQQBrowser\//i.test(userAgent)
    && !webviewInfo.isInWeixin()
    && !webviewInfo.isInQQ();
};

/**
 * 判断是否在淘宝中
 * @return {Boolean} 是否在淘宝中
 */
webviewInfo.isInTaoBao = () => {
  return / Aliapp\(TB\//i.test(userAgent);
};

/**
 *
 * @return {boolean}
 */
webviewInfo.isTaoBaoLite = () => {
  return / Aliapp\(LT\//i.test(userAgent);
}

/**
 * 判断是否在 Chrome 浏览器中
 */
webviewInfo.isInChrome = () => {
  // Mozilla/5.0 (iPhone; CPU iPhone OS 14_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/87.0.4280.77 Mobile/15E148 Safari/604.1
  // Mozilla/5.0 (iPhone; CPU iPhone OS 14_2 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0.1 Mobile/15E148 Safari/604.1
  if (os.ios) {
    return / CriOS\//i.test(userAgent);
  } else {
    // 这个判断有问题
    // return / Chrome\//i.test(userAgent);
  }
};

/**
 * 是否在知乎端内
 * @return {boolean}
 */
webviewInfo.isInZhiHu = () => {
  return / ZhihuHybrid /i.test(userAgent);
};

/**
 * 判断是不是在 Safari 浏览器中
 * @return {*|boolean}
 */
webviewInfo.isInSafari = () => {
  return os.ios && / Safari\//i.test(userAgent)
    && !webviewInfo.isInChrome()
    && !webviewInfo.isInQQBrowser();
};

const system = {
  isiOS: os.ios,
  isAndroid: os.android,
  version: os.version,
};

// 检查倒计时时间
const checkDuration = 2000;
// App store 地址
const appStoreURL = 'https://itunes.apple.com/app/id461703208?ls=1&mt=8';
// Universal Link
const universalLinkPrefix = '//m.amap.com/applink/appstore.html?schema=';
// 高德官网
const amapOfficialWebsite = 'https://wap.amap.com';
// 应用宝地址
const yingYongBaoPrefix = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.autonavi.minimap&ckey=CK1387798561597&android_schema=';
// 默认 schema
const defaultSchema = 'amapuri://rootmap?sourceApplication=callNative';
// 官网 APK 下载地址
const downloadURL = 'https://download.uc.cn/download/amap?ch=C0211000120184';

const platform = {
  // Safari
  Safari: webviewInfo.isInSafari(),
  // chrome
  Chrome: webviewInfo.isInChrome(),
  // QQ 浏览器
  QQBrowser: webviewInfo.isInQQBrowser(),
  // UC 浏览器
  UC: webviewInfo.isInUC(),
  // 微博
  Weibo: webviewInfo.isInWeibo(),
  // QQ
  QQ: webviewInfo.isInQQ(),
  // 钉钉
  DingTalk: webviewInfo.isInDingTalk(),
  // 微信
  Weixin: webviewInfo.isInWeixin(),
  // 支付宝
  Alipay: webviewInfo.isInAlipay(),
  // 淘宝
  TaoBao: webviewInfo.isInTaoBao(),

  TaoBaoLite: webviewInfo.isTaoBaoLite(),
};

callNative.platform = platform;
callNative.universalLinkPrefix = universalLinkPrefix;
callNative.appStoreURL = appStoreURL;
callNative.officalWebsite = amapOfficialWebsite;
callNative.checkDuration = checkDuration;
callNative.yingYongBaoPrefix = yingYongBaoPrefix;
callNative.defaultSchema = defaultSchema;
callNative.downloadURL = downloadURL;

const containers = Object.keys(platform).filter((item) => !!platform[item]);
let container = containers[0];

// iOS 默认匹配不到为 Safari
if (!container) {
  container = 'default';
}

console.log(`容器是-----container ${container}`);

/**
 * Universal Link 方式呼起
 * @param schema {string} 呼起的 Schema
 * @return
 */
function callByUniversalLink(schema) {
  return new Promise((resolve, reject) => {
    location.href = `${callNative.universalLinkPrefix}${encodeURIComponent(schema)}`;
    setTimeout(() => {
      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'ul',
          success: true,
        });
      } else {
        reject({
          type: 'ul',
          success: false,
        });
      }
    }, callNative.checkDuration);
  });
}


/**
 * 跳转到 App store
 */
function goAppStore() {
  return new Promise((resolve, reject) => {
    window.location.href = appStoreURL;
    setTimeout(() => {
      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'appstore',
          success: true,
        });
      } else {
        resolve({
          type: 'appstore',
          success: false,
        });
      }
    }, callNative.checkDuration);
  });
}


/**
 * 跳转应用宝
 * @param schema {string}
 */
function goYingYongBao(schema) {
  return new Promise(((resolve, reject) => {
    window.location.href = `${callNative.yingYongBaoPrefix}${encodeURIComponent(schema)}`;

    setTimeout(() => {
      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'yinyongbao',
          success: true,
        });
      } else {
        reject({
          type: 'yinyongbao',
          success: false,
        });
      }
    }, callNative.checkDuration);
  }));
}

/**
 * 使用
 * @todo 等待客户端支持
 */
function callByIntent() {
}

/**
 * 展示去浏览器的引导
 */
function showCover(schema, config) {
  return new Promise((resolve, reject) => {
    try {
      const { cover = '#weixinMask' } = config;
      const coverDom = document.querySelector(cover);
      coverDom.style.display = 'block';
      resolve({
        type: 'cover',
        success: true,
      });
    } catch (error) {
      console.log(error);
      reject({
        type: 'cover',
        success: false,
        error,
      });
    }
  });
}

/**
 * 去下载文件
 */
function goDownload() {
  return new Promise(((resolve, reject) => {
    // 去下载
    console.log('go download');
    window.location.href = callNative.downloadURL;

    setTimeout(() => {
      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'download',
          success: true,
        });
      } else {
        reject({
          type: 'download',
          success: false,
        });
      }
    }, callNative.checkDuration);
  }));
}

/**
 * 跳转高德官网
 */
function goOfficialPage() {
  return new Promise(((resolve, reject) => {
    console.log('go 官网');
    window.location.href = callNative.officalWebsite;

    setTimeout(() => {
      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'official',
          success: true,
        });
      } else {
        reject({
          type: 'official',
          success: false,
        });
      }
    }, callNative.checkDuration);
  }));
}

/**
 * 使用 Schema 唤端
 * @param schema {string} schema 地址（非 encode）
 */
function callBySchema(schema) {
  return new Promise((resolve, reject) => {
    if (system.isiOS && parseInt(system.version) > 9) {
      window.location.href = schema;
    } else {
      let schemaIframe = document.getElementById('loadSchemaIframe');
      if (!schemaIframe) {
        schemaIframe = document.createElement('iframe');
        schemaIframe.id = 'loadSchemaIframe';
        schemaIframe.style.display = 'none';
        document.body.appendChild(schemaIframe);
      }
      schemaIframe.src = schema;
    }

    // 延时判断
    setTimeout(() => {
      console.log(window.document.visibilityState)

      if (window.document.visibilityState === 'hidden') {
        resolve({
          type: 'schema',
          success: true,
        });
      } else {
        reject({
          type: 'schema',
          success: false,
        });
      }
    }, callNative.checkDuration);
  });
}

const RULES_DICT = {
  schema: callBySchema,
  ul: callByUniversalLink,
  yingyongbao: goYingYongBao,
  download: goDownload,
  appstore: goAppStore,
  browser: showCover,
  official: goOfficialPage,
  intent: callByIntent,
}

/**
 * 呼端页面
 * @param rules
 * @param callSchema
 * @param config
 * @return {Promise<unknown>}
 */
function call(rules, callSchema, config) {
  // 不合法的 schema 或者是不存在 schema 都默认跳转到高德主图
  if (!callSchema || !/^(?:(?:ios|android)amap|amapuri):\/\//i.test(callSchema) ) {
    callSchema = callNative.defaultSchema;
  }

  // 修改钉钉与微博协议头
  if ((container === 'DingTalk' || container === 'Weibo' || container === 'UC') &&
    (callSchema.indexOf('amapuri://') === 0)) {

    // 钉钉不支持新的 schema 'amapuri://webview/amaponline'
    if (callSchema.indexOf('amapuri://webview/amaponline?') === 0 ) {
      callSchema = callSchema.replace('amapuri://webview/amaponline?', 'amapuri://openFeature?featureName=OpenURL&');
    }

    const schemaURL = new URL(callSchema);
    schemaURL.protocol = os.ios ? 'iosamap' : 'androidamap';
    console.log(schemaURL);
    callSchema = schemaURL.toString();
  }

  return new Promise(async (resolve, reject) => {
    let rule = rules[container] || rules['default'] || {};
    let ruleWithSystem = system.isiOS ? rule['iOS'] : rule['Android'];
    const { action, fallback } = ruleWithSystem || {};
    let actionFn = null;
    let fallbackFn = null;

    console.log(`action: ${action}, fallback: ${fallback}·`)

    if (action) {
      actionFn = RULES_DICT[action];
    }

    if (fallback){
      fallbackFn = RULES_DICT[fallback];
    }

    if (actionFn && typeof actionFn === 'function') {
      const actionResult = await actionFn(callSchema, config).catch(res => res);
      const { success } = actionResult;
      if (!success) {
        console.log(`action ${action} 执行失败`)
        if (fallbackFn && typeof fallbackFn === 'function') {
          const fallbackResult = await fallbackFn(callSchema, config).catch(res => res);
          const { success } = fallbackResult;
          if (success) {
            console.log(`fallback ${fallback} 执行成功`);
            resolve({
              ...fallbackResult,
              isFallback: true,
            });
          } else {
            console.log(`fallback ${fallback} 执行失败`);
            reject({
              ...fallbackResult,
              isFallback: true,
            });
          }
        } else {
          console.log('fallback 没有指定');
          resolve({
            type: 'empty',
            success: false,
            isFallback: true,
          });
        }
      } else {
        console.log(`action ${fallback} 执行成功`);
        resolve(actionResult);
      }
    } else {
      console.log('action 没有指定操作')
      reject({
        type: 'empty',
        isFallback: false,
        success: false,
      });
    }
  });
}

callNative.call = call;

/**
 * 呼端
 * @param schema {string|object}
 * @param rules {Object}
 * @param addOnConfig {object}
 */
function callNative(schema, rules, addOnConfig = {
  cover: '#weixinMask',
  process() {},
  success() {},
  fail() {}
}) {
  return new Promise(async (resolve, reject) => {
    let callSchema = '';

    let {
      success = () => {},
      fail = () => {},
      process = () => {},
    } = addOnConfig;

    // 判断下schema
    /**
     * amapuri:// 双端都支持
     * todo 是不是
     */
    if (typeof schema === 'string') {
      callSchema = schema;
    } else if (typeof schema === 'object') {
      /**
       * 用于支持老的系统
       * @param schema [object] {iOS: ,android: ''}
       */
      const {
        iOS,
        android
      } = schema;

      // 默认是 Android
      callSchema = android;

      if (system.isiOS) {
        callSchema = iOS;
      }
    }

    console.log('呼起来', callSchema);

    if (!rules) {
      reject(new Error('no rules'));
      return false;
    }

    // 检查自动
    const { auto, btnClick, pageClick } = rules;

    if (auto) {
      console.log('auto');
      process({
        rule: 'auto',
      });
      let result = await call(auto, callSchema, addOnConfig).catch(res => res);
      const data = {
        ...result,
        rule: 'auto',
      }

      if (result && result.success) {
        resolve(data);
        success(data);
      } else {
        reject(data);
        fail(data)
      }
    }

    if (pageClick) {
      let body = document.querySelector('body');
      body.addEventListener('touchstart', async (e) => {
        console.log('body');
        e.preventDefault();
        e.stopPropagation();
        process({
          rule: 'pageClick',
        });

        let result = await call(pageClick, callSchema, addOnConfig).catch(res => res);
        const data = {
          ...result,
          rule: 'pageClick',
        }

        if (result && result.success) {
          resolve(data);
          success(data);
        } else {
          reject(data);
          fail(data)
        }
      });
    }

    if (btnClick) {
      let callNativeBtn = document.getElementById('callNativeBtn');
      if (callNativeBtn) {
        callNativeBtn.addEventListener('touchstart', async (e) => {
          console.log('btn');
          e.preventDefault();
          e.stopPropagation();
          process({
            rule: 'btnClick',
          })
          let result = await call(btnClick, callSchema, addOnConfig).catch(res => res);
          const data = {
            ...result,
            rule: 'btnClick',
          }

          if (result && result.success) {
            resolve(data);
            success(data);
          } else {
            reject(data);
            fail(data)
          }
        });
      }
    }
  });
}
export default callNative;
